import { ActionContext, ActionTree } from 'vuex';

import { MetaState } from './meta.state';
// import * as mutationTypes from './meta.mutations.types';

// -------------------------------------------------------------------------
// Define Types & Interfaces
// -------------------------------------------------------------------------

// -------------------------------------------------------------------------
// Define Action Types
// -------------------------------------------------------------------------

export const actionTypes = {};

// -------------------------------------------------------------------------
// Define Action Object
// -------------------------------------------------------------------------

export const actions: ActionTree<MetaState, MetaState> = {};



// WEBPACK FOOTER //
// ./src/app/store/meta/meta.actions.ts